import { Routes, Route, useLocation } from "react-router-dom"
import { AnimatePresence } from "framer-motion"

import Layout from "@/components/layout/Layout"

import Home from "@/pages/Home"
import Solutions from "@/pages/Solutions"
import Contact from "@/pages/Contact"
import AirbnbCalculator from "@/pages/AirbnbCalculator"
import Terms from "@/pages/Terms"
import Privacy from "@/pages/Privacy"
import NotFound from "@/pages/NotFound"

import BookRedirect from "@/app/BookRedirect"

export default function App() {
  const location = useLocation()

  return (
    <AnimatePresence mode="wait">
      <Routes
        location={location}
        key={location.pathname}
      >
        <Route element={<Layout />}>

          <Route
            path="/"
            element={<Home />}
          />

          <Route
            path="/solutions"
            element={<Solutions />}
          />

          <Route
            path="/revenue-calc"
            element={<AirbnbCalculator />}
          />

          <Route
            path="/contact"
            element={<Contact />}
          />

          <Route
            path="/privacy"
            element={<Privacy />}
          />

          <Route
            path="/terms"
            element={<Terms />}
          />

          <Route
            path="/book"
            element={<BookRedirect />}
          />

          <Route
            path="*"
            element={<NotFound />}
          />

        </Route>
      </Routes>
    </AnimatePresence>
  )
}